<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-card color="transparent" v-if="farm">
      <v-container fluid>
        <div class="page-title">
          <!-- <v-btn color="primary" @click="goBack" density="compact" icon="mdi-chevron-left">      <v-icon>mdi-chevron-left</v-icon></v-btn> -->
          <h2 class="text-capitalize">{{ farm.farmName }}</h2>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary"
            dark
            :to="{
              name: 'EditFarms',
              params: { farmId: this.$route.params.farmId ?? this.farm.id },
            }"
          >
            {{ $t("farm.editFarm") }}
          </v-btn>
          <v-btn
            class="ml-5"
            depressed
            outlined
            color="error"
            dark
            @click="startDelete"
          >
            {{ $t("farm.deleteFarm") }}
          </v-btn>
          <!-- <v-btn
				class="ml-5"
				depressed
				color="primary"
				dark
				@click="deleteFarm"
				>
				Delete Farm
			</v-btn> -->
        </div>

        <div class="c-right">
          <v-card flat>
            <v-card-text>
              <v-row width="100%">
                <v-col class="">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>{{
                          $t("farm.farmName")
                        }}</v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2 text-capitalize">
                          {{ farm.farmName ? farm.farmName : "N/A" }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-divider vertical inset></v-divider>
                <v-col class="">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          {{ $t("farm.farm_Owner") }}
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2 text-capitalize">
                          {{
                            farm.userAssoc.firstName +
                            " " +
                            farm.userAssoc.lastName
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-divider vertical inset></v-divider>
                <v-col class="">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          #{{ $t("farm.govtRegistry") }}
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2 text-capitalize">
                          {{ farm.govRegistrationNum }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-divider vertical inset></v-divider>
                <v-col class="" v-if="farm.farmOwnershipType =='corporate'">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          {{ $t("cooperativeId") }}
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2 text-capitalize">
                          {{ farm.cooperativeId }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-divider vertical inset></v-divider>
                <v-col class="" v-if="farm.farmOwnershipType =='corporate'">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          {{ $t("farm.cooperativeName") }}
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2 text-capitalize">
                          {{ farm.cooperativeName }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-divider vertical inset></v-divider>
                <v-col class="">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          {{ $t("farm.dateOfRegistration") }}
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2">
                          {{ formatDate(farm.createdAt) }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
        <template>
          <v-card class="px-5" flat>
            <v-tabs
              left
              v-model="tab"
              background-color="transparent"
              color="primary"
            >
              <v-tab class="text-capitalize" v-for="item in items" :key="item">
                {{ item }}
              </v-tab>
            </v-tabs>
            <v-divider></v-divider>
            <v-tabs-items v-model="tab" class="mt-5">
              <v-tab-item>
                <information :farm="farm"></information>
              </v-tab-item>
              <v-tab-item>
                <licence :farm="farm" :dateFormat="format"></licence>
              </v-tab-item>
              <v-tab-item>
                <location :farm="farm"></location>
              </v-tab-item>
              <!-- <v-tab-item>
					<geolocation :farm="farm"></geolocation>
				</v-tab-item> -->
            </v-tabs-items>
          </v-card>
        </template>
        <div class="mt-5 mb-5">
          <div class="page-title mt-5">
            <h2>{{ $t("farm.farmAnimals") }}</h2>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              depressed
              outlined
              @click="
                $router.push({ name: 'AddAnimal', params: { type: 'single' } })
              "
            >
              {{ $t("farm.registerAnAnimal") }}
            </v-btn>
          </div>

          <register-animal-dialog
            v-if="showRegisterAnimalDialog"
            :dialogI="showRegisterAnimalDialog"
            @closeDialog="showRegisterAnimalDialog = false"
          ></register-animal-dialog>
        </div>
        <template>
          <v-card flat color="transparent">
            <v-container class="mb-5" grid-list-xl fluid>
              <v-layout row wrap>
                <v-flex
                  xs6
                  sm4
                  md2
                  xl2
                  class="lg5-custom mb-5"
                  :style="
                    $vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }
                  "
                >
                  <v-card flat min-height="90">
                    <div class="section-boxes1">
                      <div class="boxes-data">
                        <div class="box-inline-tab">
                          <div class="circle-img">
                            <v-img size="50" src="/icons/dam.png"></v-img>
                          </div>
                          <div class="box-deatils-part">
                            <h2>{{ $t("Lactating Cows") }}</h2>
                            <p>
                              {{
                                (animalCountByFarmLocationId &&
                                  animalCountByFarmLocationId?.lactatingCows) ||
                                0
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-flex>
                <v-flex
                  xs6
                  sm4
                  md2
                  xl2
                  :style="
                    $vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }
                  "
                  class="lg5-custom mb-5"
                >
                  <v-card flat min-height="90">
                    <div class="section-boxes1">
                      <div class="boxes-data">
                        <div class="box-inline-tab">
                          <div class="circle-img">
                            <v-img size="50" src="/icons/sire.png"></v-img>
                          </div>
                          <div class="box-deatils-part">
                            <h2>{{ $t("Dry Cows") }}</h2>
                            <p>
                              {{
                                (animalCountByFarmLocationId &&
                                  animalCountByFarmLocationId?.dryCows) ||
                                0
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-flex>
                <v-flex
                  xs6
                  sm4
                  md2
                  xl2
                  :style="
                    $vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }
                  "
                  class="lg5-custom mb-5"
                >
                  <v-card flat min-height="90">
                    <div class="section-boxes1">
                      <div class="boxes-data">
                        <div class="box-inline-tab">
                          <div class="circle-img">
                            <v-img size="50" src="/icons/heifer.png"></v-img>
                          </div>
                          <div class="box-deatils-part">
                            <h2>{{ $t("Heifers") }}</h2>
                            <p>
                              {{
                                (animalCountByFarmLocationId &&
                                  animalCountByFarmLocationId.heifer) ||
                                0
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-flex>
                <v-flex
                  xs6
                  sm4
                  md2
                  xl2
                  :style="
                    $vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }
                  "
                  class="lg5-custom mb-5"
                >
                  <v-card flat min-height="90">
                    <div class="section-boxes1">
                      <div class="boxes-data">
                        <div class="box-inline-tab">
                          <div class="circle-img">
                            <v-img size="50" src="/icons/steer.png"></v-img>
                          </div>
                          <div class="box-deatils-part">
                            <h2>{{ $t("Bulls") }}</h2>
                            <p>
                              {{
                                (animalCountByFarmLocationId &&
                                  animalCountByFarmLocationId.bulls) ||
                                0
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-flex>
                <v-flex
                  xs6
                  sm4
                  md2
                  xl2
                  :style="
                    $vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }
                  "
                  class="lg5-custom mb-5"
                >
                  <v-card flat min-height="90">
                    <div class="section-boxes1">
                      <div class="boxes-data">
                        <div class="box-inline-tab">
                          <div class="circle-img">
                            <v-img size="50" src="/icons/calf.png"></v-img>
                          </div>
                          <div class="box-deatils-part">
                            <h2>{{ $t("Calves") }}</h2>
                            <p>
                              {{
                                (animalCountByFarmLocationId &&
                                  animalCountByFarmLocationId.calves) ||
                                0
                              }}
                            </p>
                          </div>
                        </div>
                        <div class="arrow-icon">
                          <div class="three-dot">
                            <v-icon>mdi-dots-horizontalss</v-icon>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </template>
      </v-container>
    </v-card>
    <v-card v-else flat color="transparent" class="px-10 mt-5">
      <div class="text-center white" style="min-height: 70vh">
        <v-row justify="center" align="center">
          <v-col cols="12" sm="4">
            <div class="py-16">
              <img src="/img/Notes.svg" /><br />
              <!-- <strong>No Farm Found</strong><br /> -->
              <div class="pb-4">
                <small
                  >{{ $t('noFarmMsg') }}
                  <br />
                  {{ $t('noFarmMsg2') }}</small
                >
              </div>
              <v-btn
                depressed
                color="primary"
                dark
                @click="$router.push({ name: 'FarmRegistartion' })"
              >
                {{ $t("farm.registerAfarm") }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-dialog
      v-model="showDeleteConfirm"
      transition="dialog-top-transition"
      max-width="650"
    >
      <template>
        <v-card rounded="0">
          <v-toolbar color="secondary" class="white--text">
            <v-toolbar-title class="font-weight-bold">
              {{$t('deleteFarmH')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon class="white--text" @click="showDeleteConfirm = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text
            class="black--text py-10 font-weight-bold"
            style="font-size: 16px"
          >
            <span>
              {{ $t('deleteFarmMsg') }}
              <br /><br />              

              {{ $t('deleteFarmMsg2') }}
              <span style="color: #ff0000">{{ noOfAnimalsInFarm }} </span>
              {{ $t('deleteFarmMsg3') }}
              <br /><br />

              {{ $t('deleteFarmMsg4') }}
            </span>
          </v-card-text>
          <v-card-actions class="px-4 py-5 justify-center">
            <div>
              <v-spacer></v-spacer>
              <v-btn
                @click="showDeleteConfirm = false"
                outlined
                class="mr-2 px-5"
                right
                height="44"
                depressed
                color="primary"
              >
                {{ $t('cancel') }}
              </v-btn>
              <v-btn
                @click="deleteFarm"
                right
                height="44"
                color="error"
                class="px-5"
              >
              {{ $t('delete') }}
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Breadcrumb from "@/components/core/Breadcrumb";
import FarmService from "@/_services/farmService";
import Licence from "./single_farm/Licence.vue";
import Information from "./single_farm/Information.vue";
import Location from "./single_farm/Location.vue";
// import Geolocation from "./single_farm/Geolocation.vue";
import loadingMixin from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin"
import _ from "lodash";
import gql from "graphql-tag";

import {
  getUserFarmByFarmId,
  getFarmAnimalsCount,
  animalCountByFarmLocationId,
} from "@/graphql/Farm.gql";

export default {
  components: {
    breadcrumb: Breadcrumb,
    Licence,
    Information,
    Location,
    // Geolocation,
  },
  computed: {},
  apollo: {
    // animalsCount: {
    //   query: gql`
    //     query animalsCount {
    //       generalInformationsCount {
    //         calf
    //         dam
    //         heifer
    //         sire
    //         steer
    //         group
    //         male
    //         female
    //         archived
    //         all
    //       }
    //     }
    //   `,
    //   fetchPolicy: "network-only",
    //   update: (data) => data.generalInformationsCount,
    // },
    animalCountByFarmLocationId: {
      query: animalCountByFarmLocationId,
      fetchPolicy: "network-only",
      variables() {
        return {
          farmId: this.$route?.params?.farmId
            ? Number(this.$route?.params?.farmId)
            : Number(this.farm.id),
        };
      },
      update: data => data.animalCountByFarmLocationId,
      result({ data }) {
        const { bulls, calves, dryCows, heifer, lactatingCows } =
          data.animalCountByFarmLocationId;
        this.noOfAnimalsInFarm =
          bulls + calves + dryCows + heifer + lactatingCows;
      },
    },
    getFarmAnimalsCount: {
      query: getFarmAnimalsCount,
      fetchPolicy: "network-only",
      skip: () => true,
      variables() {
        return {
          farmId: Number(this.$route?.params?.farmId),
        };
      },
      update: data => data.getFarmAnimalsCount,
    },
    birthOriginByFarmId: {
      query: gql`
        query birthOriginByFarmId($farmId: Int!) {
          birthOriginByFarmId(farmId: $farmId)
        }
      `,
      fetchPolicy: "network-only",
      skip: () => true,
      variables() {
        return {
          farmId: Number(this.farm.id),
        };
      },
    },
  },
  data() {
    return {
      noOfAnimalsInFarm: 0,
      showDeleteConfirm: false,
      showRegisterAnimalDialog: false,
      farm: null,
      date: "",
      tab: null,
      farmID: "",
      items: [
        this.$t("farm.information"),
        this.$t("farm.licenseInfo"),
        this.$t("Location and Size"),
        // this.$t('farm.geoLocation')
      ],
      animal: {},
      search: "",
      farmId: "",
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("myFarm"),
          link: true,
          exact: true,
          disabled: false,
          to: { name: "My farm" },
        },
      ],
    };
  },

  async mounted() {
    try {
      document.title = "My Farm";
      this.startLoading();
      if (this.$route?.params?.farmId) {
        const { data } = await this.$apollo.query({
          query: getUserFarmByFarmId,
          fetchPolicy: "no-cache",
          variables: {
            farmId: Number(this.$route?.params?.farmId),
          },
        });
        this.stopLoading();
        if (_.isEmpty(data)) {
          return;
        }
        this.farm = data.getUserFarmByFarmId;
      }
      // else {
      //   const { data } = await FarmService.getPrimaryFarm();
      //   await this.$store.dispatch("setFarmData", data);
      //   localStorage.setItem("farmID", data.id);
      //   this.stopLoading();
      //   if (_.isEmpty(data)) {
      //     return;
      //   }
      //   this.farm = data;
      // }
    } catch (error) {
      this.stopLoading();
      console.log(error);
      return;
    }
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async startDelete() {
      console.log("start delete farm");
      this.showDeleteConfirm = true;
      // this.$apollo.queries.birthOriginByFarmId.skip = false;
      // let res = await this.$apollo.queries.birthOriginByFarmId.refetch();
      // this.noOfAnimalsInFarm = res.data.birthOriginByFarmId
    },
    async deleteFarm() {
      this.startLoading();
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation ($farmId: Int!) {
              deleteFarm(farmId: $farmId)
            }
          `,
          // Parameters
          variables: {
            farmId: Number(this.farm.id),
          },
        })
        .then(async () => {
          this.showDeleteConfirm = false;
          this.farm = null;
          this.stopLoading();
        })
        .catch(async error => {
          console.log(error);
          this.stopLoading();
        });
      console.log("delete farm");
    },

    format(inputDate) {
      var date = new Date(inputDate);
      if (!isNaN(date.getTime())) {
        console.log("mm", date.getMonth());
        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
      }
    },
  },
  mixins: [loadingMixin, generalMixin],
};
</script>
<style lang="scss" scoped>
.c-right {
  padding: 0px 0px 50px !important;
}

.page-title p {
  color: $primary-color;
}

.section-boxes1 {
  // border-bottom: 1px solid #ccc;
  padding: 8px;
}
.section-boxes1 .boxes-data {
  display: flex;
  justify-content: space-between;
}
.section-boxes1 .box-inline-tab {
  display: flex;
  align-items: center;
}
.section-boxes1 .circle-img {
  background: paleturquoise;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.section-boxes1 .box-deatils-part {
  margin-top: 12px;
  margin-left: 14px;
}
.section-boxes1 .box-deatils-part h2 {
  font-size: 13px;
  color: grey;
}
.section-boxes1 .box-deatils-part p {
  font-size: 29px;
  margin-top: 1px;
}
.three-dot {
  margin-bottom: 9px;
}

.flex.lg5-custom {
  width: 20%;
  max-width: 80%;
  flex-basis: 20%;
}
.route {
  text-decoration: none !important;
  position: absolute;
  top: 15px;
  right: 10px;
}
.no-line-break {
  white-space: nowrap;
}
::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}
</style>
